import { render, staticRenderFns } from "./AbkMessageSecondary.vue?vue&type=template&id=005fa962&scoped=true&"
import script from "./AbkMessageSecondary.vue?vue&type=script&lang=js&"
export * from "./AbkMessageSecondary.vue?vue&type=script&lang=js&"
import style0 from "./AbkMessageSecondary.vue?vue&type=style&index=0&id=005fa962&scoped=true&lang=scss&"
import style1 from "./AbkMessageSecondary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fa962",
  null
  
)

export default component.exports